import types from "../actionTypes";

export default (
  state = {
    isAuthenticating: false,
    isAuthenticated: false,
    isAuthenticationFailed: false,
    isSessionValid: false,
    isPasswordExpired:false,
    isLogin:false,
    isModalNotification:false
  },
  action
) => {
  switch (action.type) {
    case types.IS_AUTHENTICATING:
      return Object.assign({}, state, {
        isAuthenticating: action.isAuthenticating,
      });
    case types.IS_AUTHENTICATED:
      return Object.assign({}, state, {
        isAuthenticated: action.isAuthenticated,
      });
    case types.IS_AUTHENTICATION_FAILED:
      return Object.assign({}, state, {
        isAuthenticationFailed: action.isAuthenticationFailed,
      });
    case types.IS_SESSION_VALID:
      return Object.assign({}, state, {
        isSessionValid: action.isSessionValid,
      });
      case types.SET_IS_PASSWORD_EXPIRED:
      return Object.assign({}, state, {
        isPasswordExpired: action.isPasswordExpired,
      });
      case types.SET_AUTH_TOKEN:
      return Object.assign({}, state, {
        authToken: action.authToken,
      });
      case types.SET_IS_LOGIN:
      return Object.assign({}, state, {
        isLogin: action.isLogin,
      });
      case types.SET_ON_LOGIN_MODALNOTIFICATION:
        return Object.assign({}, state, {
          isModalNotification: action.isModalNotification,
        });
    default:
      return state;
  }
};
